import { Component, OnInit } from '@angular/core';
import { PwaInstallService } from '../pwa-install.service';

/**
 * Notice d'installation iOS — fidèle à la maquette : iOS ne propose pas d'invite
 * programmable, on guide l'utilisateur (Partager → « Sur l'écran d'accueil »).
 * Affichée uniquement sur iOS Safari, hors mode déjà installé, et seulement si
 * la PWA est activée pour l'environnement courant (cf. PwaInstallService).
 */
@Component({
  selector: 'pwa-ios-install-sheet',
  templateUrl: './pwa-ios-install-sheet.component.html',
  styleUrls: ['./pwa-ios-install-sheet.component.scss'],
  standalone: false,
})
export class PwaIosInstallSheetComponent implements OnInit {
  show = false;

  constructor(private readonly install: PwaInstallService) {}

  ngOnInit(): void {
    this.show =
      this.install.isIosInstallAvailable && !this.install.installInviteDismissed;
  }

  dismiss(): void {
    this.show = false;
    this.install.dismissInstall();
  }
}
